import { SET_GENERAL_ERROR, DELETE_GENERAL_ERROR } from "../types";
import {ERROR} from '../reducer/error'
import { v4 as uuidV4 } from "uuid";

export function setError(message) {
  return function(dispatch) {
    let id = uuidV4();
    dispatch({
      type: ERROR.create,
      payload: { message, id },
    });

    // remove error from
    setTimeout(
      () => dispatch({ type: ERROR.delete, payload: id }),
      3000
    );
  };
}
